/** HMS returns this when the provider has no active subscription */
export const HMS_SUBSCRIPTION_INACTIVE_ERRORCODE = 2525;

/** Dispatched on window when HMS responds with {@link HMS_SUBSCRIPTION_INACTIVE_ERRORCODE} */
export const HMS_SUBSCRIPTION_INACTIVE_EVENT = 'nexthome:hms-subscription-inactive';

export function isHmsSubscriptionInactiveError(error) {
  return Number(error?.response?.data?.errorcode) === HMS_SUBSCRIPTION_INACTIVE_ERRORCODE;
}

/**
 * Utility function to check if an error response indicates "no data" (not an actual error)
 * When API returns status 400 with errorcode 2003, it means there's no data available,
 * not that an error occurred.
 * 
 * @param {Error} error - The error object from axios/fetch
 * @returns {boolean} - True if this is a "no data" case, false otherwise
 */
export function isNoDataError(error) {
  if (!error?.response) {
    return false;
  }

  const status = error.response.status;
  const errorData = error.response.data;
  const errorcode = errorData?.errorcode;

  // Check if status is 400 and errorcode is 2003
  if (status === 400 && errorcode === 2003) {
    return true;
  }

  return false;
}

/**
 * Helper function to handle API errors, treating "no data" cases appropriately
 * 
 * @param {Error} error - The error object from axios/fetch
 * @param {Function} onNoData - Callback when it's a "no data" case (optional)
 * @param {Function} onError - Callback when it's an actual error (optional)
 * @returns {Object} - Object with { isNoData: boolean, shouldHandleAsError: boolean }
 */
export function handleApiErrorResponse(error, onNoData = null, onError = null) {
  const isNoData = isNoDataError(error);

  if (isNoData) {
    if (onNoData) {
      onNoData();
    }
    return { isNoData: true, shouldHandleAsError: false };
  } else {
    if (onError) {
      onError();
    }
    return { isNoData: false, shouldHandleAsError: true };
  }
}


